export default function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}


//////////////////
// WEBPACK FOOTER
// /var/www/gl.a9.smashy.space/public/wp-content/themes/ga-lending/node_modules/@popperjs/core/lib/utils/getAltAxis.js
// module id = 61
// module chunks = 0